<template lang="pug">
div
  v-container.pa-0(fluid)
    div.d-flex.justify-center.mt-16(v-if="isFetching")
      v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

    template(v-else-if="stockTake")
      div.pa-4
        .heading-5.font-semibold.neutral700--text {{ stockTake.name }}
        .text-lg.neutral700--text {{ stockTake.created | humanizeDatewithDay }}

        div.mt-6
          div.d-flex
            v-icon(color="neutral700" size="22") $yzi-users-solid-03
            div.text-sm.neutral700--text.ml-3 {{ stockTake.member.name }}
          div.d-flex.mt-3
            v-icon(color="neutral700" size="22") $yzi-clock-check-solid
            div.text-sm.neutral700--text.font-semibold.ml-3 Time taken:
            div.text-sm.neutral700--text.ml-1 {{ getTimeDifference }}
          div.d-flex.mt-3
            v-icon(color="neutral700" size="22") $yzi-marker-pin-solid-04
            div.text-sm.neutral700--text.font-semibold.ml-3 Location involved{{ stockTake.summary && stockTake.summary.locations ? ` (${stockTake.summary.locations.length})` : '' }}:
              span.text-sm.font-normal.neutral700--text.ml-1(v-if="stockTake.summary && stockTake.summary.locations") {{ stockTake.summary.locations.join(', ') }}
              span.text-sm.font-normal.neutral700--text.ml-1(v-else) -
          div.d-flex.mt-3
            v-icon(color="neutral700" size="22") $yzi-package-check-solid
            div.text-sm.neutral700--text.font-semibold.ml-3 Count:
            v-progress-circular.ml-4(v-if="isFetchingTotal" :width="2" :size="16" color="primary" indeterminate)
            div.text-sm.neutral700--text.ml-1(v-else) {{ changedProducts.length }} of {{ totalCount }} inventories counted
          div.d-flex.mt-3
            v-icon(color="neutral700" size="22") $yzi-calendar-solid
            div.text-sm.neutral700--text.font-semibold.ml-3 Start date and time:
            div.text-sm.neutral700--text.ml-1 {{ stockTake.created | convertServerDate2 }}
          div.d-flex.mt-3
            v-icon(color="neutral700" size="22") $yzi-calendar-check-solid-01
            div.text-sm.neutral700--text.font-semibold.ml-3 End date and time:
            div.text-sm.neutral700--text.ml-1(v-if="stockTake.finished_at") {{ stockTake.finished_at | convertServerDate2 }}
            div.text-sm.neutral700--text.ml-1(v-else) -          

      v-divider
      template(v-if="stockTake.summary")
        div.text-lg.font-semibold.neutral700--text.mt-6.px-4 Stock take summary
        div.px-4.py-3
          div.d-flex.align-center
            div.text-sm.neutral700--text Type
            v-spacer
            div.text-sm.font-semibold.neutral700--text Current stock
          div.d-flex.align-center.mt-1
            div.text-sm.neutral700--text Locations
            v-spacer
            div.text-sm.font-medium.neutral700--text.underline.clickable(v-if="stockTake.summary.locations.length" @click="openLocationSheet = true") {{ stockTake.summary.locations.length > 1 ? `${stockTake.summary.locations.length} locations` : '1 location' }}
            div.text-sm.font-medium.neutral700--text(v-else) -
          div.d-flex.align-center.mt-1
            div.text-sm.neutral700--text Quantity
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ stockTake.summary.current_stock.quantity }}
          div.d-flex.align-center.mt-1
            div.text-sm.neutral700--text Value
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ stockTake.summary.current_stock.value | displayPrice($currency) }}
        v-divider

        div.px-4.py-3
          div.d-flex.align-center
            div.text-sm.neutral700--text Type
            v-spacer
            div.text-sm.font-semibold.neutral700--text Actual stock
          div.d-flex.align-center.mt-1
            div.text-sm.neutral700--text Locations
            v-spacer
            div.text-sm.font-medium.neutral700--text.underline.clickable(v-if="stockTake.summary.locations.length" @click="openLocationSheet = true") {{ stockTake.summary.locations.length > 1 ? `${stockTake.summary.locations.length} locations` : '1 location' }}
            div.text-sm.font-medium.neutral700--text(v-else) -
          div.d-flex.align-center.mt-1
            div.text-sm.neutral700--text Quantity
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ stockTake.summary.actual_stock.quantity }}
          div.d-flex.align-center.mt-1
            div.text-sm.neutral700--text Value
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ stockTake.summary.actual_stock.value | displayPrice($currency) }}
        v-divider

        div.px-4.py-3.neutral200
          div.text-sm.font-semibold.neutral700--text Difference:
          div.d-flex.align-center.mt-1
            div.text-sm.neutral700--text Quantity
            v-spacer
            div.text-sm.font-semibold.neutral700--text {{ stockTake.summary.actual_stock.quantity - stockTake.summary.current_stock.quantity }}
          div.d-flex.align-center.mt-1
            div.text-sm.neutral700--text Value
            v-spacer
            div.text-sm.font-semibold.neutral700--text {{ (stockTake.summary.actual_stock.value - stockTake.summary.current_stock.value) | displayPrice($currency) }}
        v-divider
      
      v-divider.mt-4
      div.d-flex.align-center.pa-4.clickable(@click="showItems = !showItems")
        div.text-lg.font-semibold {{ productCount }} items counted
        v-spacer
        v-icon(v-if="showItems") $yzi-chevron-up
        v-icon(v-else) $yzi-chevron-down
      v-divider

      template(v-if="showItems")
        div.d-flex.justify-center.mt-16(v-if="isFetchingProducts")
          v-progress-circular(:width="2" :size="30" color="primary" indeterminate)
        
        template(v-else)
          template(v-for="product in products")
            div.pa-4(:key="product.id")
              v-row(no-gutters)
                v-col.pr-1(cols="6" style="word-break: break-word;")
                  .text-sm.font-semibold.neutral700--text {{ product.product.name }}
                v-col.pl-1(cols="6" align="right" style="word-break: break-word;")
                  .text-sm.neutral700--text(v-if="getStockUnit(product)") {{ getStockUnit(product) }}
                  .text-sm.font-medium.success500--text Current count: {{ product.balance - product.change }}
                  .text-sm.font-medium.info500--text Actual count: {{ product.balance }}
            v-divider

          template(v-if="!products.length")
            div.mt-10.text-sm.neutral500--text.text-center No item found

          div.d-flex.align-center.pa-4(v-if="productCount > pageSize")
            v-spacer
            yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="productCount" attach menu-top @input="pageChanged")

      div.py-6

  .dialogs
    location-involved-bottom-sheet(v-if="openLocationSheet" :open.sync="openLocationSheet" :stocktake="stockTake")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LocationInvolvedBottomSheet from '@/components/clinic/inventory/stocktake/LocationInvolvedBottomSheet.vue'

export default {
  components: { LocationInvolvedBottomSheet },
  props: ['id'],
  data () {
    return {
      isLoading: false,
      isFetching: false,
      isFetchingProducts: false,
      isFetchingTotal: false,
      openLocationSheet: false,
      showItems: false,
      stockTake: null,
      pageSize: 20,
      productCount: 0,
      totalCount: 0,
      currentPage: 1,
      products: [],
      oriProducts: [],
      changedProducts: [],
      headers: [
        { text: 'Item', value: 'name', class: 'text-table-header' },
        { text: 'UOM', value: 'uom', class: 'text-table-header' },
        { text: 'Current stock', value: 'inventory_qty', class: 'text-table-header' },
        { text: 'Actual stock', value: 'actual_stock', class: 'text-table-header' },
        { text: 'Stock difference', value: 'stock_difference', class: 'text-table-header' }
      ],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    getTimeDifference () {
      if (this.stockTake && this.stockTake.created && this.stockTake.finished_at) {
        const created = new Date(this.stockTake.created).getTime()
        const finished = new Date(this.stockTake.finished_at).getTime()
        const timeDifference = Math.abs(finished - created)
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24))
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))

        let daysText = days ? days > 1 ? `${days} days ` : '1 day ' : ''
        let hoursText = hours ? hours > 1 ? `${hours} hours ` : '1 hour ' : ''
        let minutesText = minutes ? minutes > 1 ? `${minutes} minutes` : '1 minute' : ''

        return daysText + hoursText + minutesText
      }
      return '-'
    },
  },
  watch: {
    pageSize () {
      this.currentPage = 1
      this.fetchProducts()
    },
  },
  mounted () {
    this.fetchStockTake()
    this.fetchProductTotal()
  },
  methods: {
    getStockUnit (item) {
      if (item.uom_conversion_enabled && item.uom_conversions && item.uom_conversions.length) {
        return item.uom_conversions[item.uom_conversions.length - 1].convert_to || ''
      }
      return item.uom || ''
    },
    ...mapActions(['showMessage']),
    fetchStockTake () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/stock_takes/${this.id}`)
        .then(resp => {
          this.stockTake = resp.data
          this.oriProducts = JSON.parse(JSON.stringify(resp.data.products))
          this.changedProducts = JSON.parse(JSON.stringify(resp.data.products))
          this.fetchProducts()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchProducts () {
      this.isFetchingProducts = true
      let params = {
        stock_take: this.stockTake.id,
        company: this.company.id,
        page: this.currentPage,
        page_size: this.pageSize
      }
      this.$axios.get(`/product_inventories`, { params })
        .then(resp => {
          this.products = resp.data.results
          this.productCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingProducts = false
        })
    },
    fetchProductTotal () {
      this.isFetchingTotal = true
      let params = {
        status: 'published',
        page_size: 1,
        fields: 'id'
      }
      this.$axios.get(`/clinics/${this.company.slug}/inventories`, { params })
        .then(resp => {
          this.totalCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingTotal = false
        })
    },
    pageChanged () {
      this.fetchProducts()
    },
    closeStockTakeSummary () {
      window.location.href = 'https://yezza.com'
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
.button-box {
  border-left: solid 1px var(--v-neutral400);
  border-top: solid 1px var(--v-neutral400);
  border-bottom: solid 1px var(--v-neutral400);
  border-radius: 10px 0 0 10px;
  background-color: var(--v-neutral200);
}
</style>